<template>
  <form id="create_user_form">
    <div class="card card-custom gutter-b">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">افزودن کاربر</h3>
        </div>
      </div>
      <div class="card-body">
        <div class="container">
          <div class="row">
            <div class="form-group col-6">
              <label>نام</label>
              <input
                type="text"
                name="first_name"
                v-model="form.first_name"
                class="form-control form-control-solid"
              />
            </div>
            <div class="form-group col-6">
              <label> نام خانوادگی</label>
              <input
                type="text"
                name="last_name"
                v-model="form.last_name"
                class="form-control form-control-solid"
              />
            </div>
            <div class="form-group col-6">
              <label>ایمیل</label>
              <input
                type="email"
                name="email"
                v-model="form.email"
                class="form-control form-control-solid"
              />
            </div>
            <div class="form-group col-6">
              <label>شماره موبایل</label>
              <the-mask
                mask="09## ### ## ##"
                v-model="form.cellphone"
                :masked="true"
                name="cellphone"
                ref="cellphone"
                placeholder="09__ ___ __ __"
                class="form-control form-control-solid"
                dir="ltr"
                autocomplete="off"
              ></the-mask>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import { STORE_COMPANY_USER } from "@/core/services/store/company/users.module";
import { mapGetters } from "vuex";
import { TheMask } from "vue-the-mask";

export default {
  name: "companyUsersCreate",
  data() {
    return {
      form: {
        first_name: "",
        last_name: "",
        email: "",
        cellphone: "",
        is_company_user: true,
        is_referred_user: false
      }
    };
  },
  components: {
    TheMask
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: this.currentUserProperty.title ?? "شرکت",
        route: { name: "company-dashboard" }
      },
      { title: "کاربران", route: { name: "company-users-index" } },
      { title: "افزودن" }
    ]);

    this.$store.dispatch(SET_ACTIONS, {
      buttons: [
        {
          name: "ذخیره",
          event: "save-user-event",
          class: "btn-primary",
          id: "save-user-btn"
        }
      ],
      links: [
        {
          name: "بازگشت",
          to: { name: "company-users-index" }
        }
      ]
    });
    this.eventHub.$on("save-user-event", this.save);
    this.eventHub.$on("delete-user-event", this.destroy);

    this.fv = formValidation(document.getElementById("create_user_form"), {
      fields: {
        first_name: {
          validators: {
            notEmpty: {
              message: "نام صحیح نیست."
            }
          }
        },
        last_name: {
          validators: {
            notEmpty: {
              message: "نام صحیح نیست."
            }
          }
        },
        email: {
          validators: {
            emailAddress: {
              message: "ایمیل صحیح نیست."
            }
          }
        },
        cellphone: {
          validators: {
            notEmpty: {
              message: "شماره موبایل صحیح نیست"
            },
            stringLength: {
              min: 14,
              max: 14,
              message: "موبایل صحیح نیست"
            }
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        bootstrap: new Bootstrap()
      }
    });
  },
  beforeDestroy() {
    this.eventHub.$off(["save-user-event"]);
    document.getElementById("save-user-btn").disabled = false;
  },
  computed: {
    ...mapGetters(["currentUserProperty", "companyUser"])
  },
  methods: {
    save() {
      this.fv.validate().then(status => {
        if (status === "Valid") {
          let submitBtn = document.getElementById("save-user-btn");
          this.disableBtn(submitBtn);
          this.$store
            .dispatch(STORE_COMPANY_USER, {
              first_name: this.form.first_name,
              last_name: this.form.last_name,
              email: this.form.email,
              cellphone: this.parsePhone(this.form.cellphone),
              is_company_user: this.form.is_company_user,
              is_referred_user: this.form.is_referred_user
            })
            .then(user => {
              this.enableBtn(submitBtn);
              this.$router.push({
                name: "company-users-show",
                params: { id: user.id }
              });
            })
            .catch(() => {
              this.enableBtn(submitBtn);
            });
        } else if (status === "Invalid") {
          this.showError("لطفا فرم را به شکل صحیح کامل کنید");
        }
      });
    }
  }
};
</script>
